import _ from 'lodash';

export const triggerStateChangedRequest = () => {
  window.canvas.fire('custom:state:changed', {});
};

export const triggerStateChangedRequestDebounced = _.debounce(() => {
  triggerStateChangedRequest();
}, 300);
